import React from 'react';
import PropTypes from 'prop-types';

import Logo from './Logo';

const ProgramLogos = props => {
	return (
		<React.Fragment>
			{props.programLogos.map(flag => {
				const { alt, link, target } = props.logoInfo[flag];
				let { params } = props.logoInfo[flag];
				params = params
					? params.replace('$dealerCode', props.dealerCode)
					: null;

				return (
					<Logo
						key={flag}
						href={link}
						params={params}
						target={target}
						className={`${flag} pt-4 px-4 pb-3`}
						src={`https://static.dealer.com/assets/images/logos/oem-subaru/footer-logo-${flag}.png`}
						alt={alt}
					/>
				);
			})}
		</React.Fragment>
	);
};

ProgramLogos.defaultProps = {
	programLogos: [],
	dealerCode: ''
};

ProgramLogos.propTypes = {
	programLogos: PropTypes.arrayOf(PropTypes.string),
	dealerCode: PropTypes.string,
	logoInfo: PropTypes.shape({}).isRequired
};

export default ProgramLogos;
